export default __webpack_public_path__ + "static/media/regulatory--no-trailers--g1.309aba75.png";